import React, { useContext, useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import Navbar from '../compnents/Navbar';
import Footer from '../compnents/Footer';
import HeroSection from '../compnents/landingComponents/HeroSection';
import WhyFinansee from '../compnents/landingComponents/WhyFinansee';
import HowItWorks from '../compnents/landingComponents/HowItWorks';
import ProofYouCanTrust from '../compnents/landingComponents/ProofYouCanTrust';
import AuthContext from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import useDocumentMeta from '../hooks/useDocumentMeta';

const LandingPage = () => {
  useDocumentMeta({
    title: 'Behavioral Intelligence Platform for Banks & Wealth Managers | FinanSee',
    description:
      'Explore role-specific work queues for banks and wealth managers. Behavioral signals and context for human advisory review. Watch the platform presentation and explore features and plans.',
    canonical: 'https://playground.finansee.eu/',
  });

  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="brand.quantumBg">
      <Navbar />

      <Box flex="1">
        <HeroSection />
        <WhyFinansee />
        <HowItWorks />
        <ProofYouCanTrust />
      </Box>

      <Footer />
    </Box>
  );
};

export default LandingPage;
